import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
import { jsx as _jsx } from "react/jsx-runtime";
var InfoIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/_jsx(BaseSvg, _objectSpread(_objectSpread({}, otherProps), {}, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden,
    children: /*#__PURE__*/_jsx("path", {
      d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM8.33849 9.38713L8.28258 9.36368L8.28168 9.36278C7.89029 9.4719 7.51964 9.65407 7.18507 9.90026L6.9515 9.4728C7.78838 8.61788 8.5543 8.14034 9.67346 7.89505C9.79611 7.88783 9.91425 7.94735 9.99 8.05467C10.1559 8.29365 10.1559 8.78154 9.98459 9.46692L9.37225 12.0642C9.30372 12.3564 9.28748 12.5602 9.41915 12.6801C9.80693 12.5845 10.1677 12.3825 10.4671 12.0948L10.7313 12.4889C10.008 13.3853 9.30164 13.8827 8.23028 14.0964C8.05081 14.1136 7.87406 14.0351 7.75772 13.8845C7.57826 13.6275 7.57375 13.1396 7.7487 12.3857L8.28348 9.91469C8.35112 9.62701 8.38178 9.44845 8.33849 9.38713ZM9.37904 4C8.65904 3.978 8.04904 4.551 8.02304 5.27C8.00104 5.542 8.09204 5.81 8.27404 6.013C8.47904 6.206 8.75504 6.306 9.03604 6.291C9.76204 6.304 10.375 5.729 10.409 5.003C10.409 4.99612 10.4093 4.98924 10.4095 4.98224C10.4098 4.975 10.41 4.96763 10.41 4.96C10.41 4.432 9.97504 3.997 9.44704 3.997C9.42404 3.997 9.40204 3.998 9.37904 4Z"
    })
  }));
});
InfoIcon.displayName = 'InfoIcon';
export default InfoIcon;